import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useLang } from "../i18n";

export default function Seo({ title, description, image, noindex = false, type = "website" }) {
  const { lang } = useLang();
  const { pathname } = useLocation();
  const origin = window.location.origin;
  const bare = pathname.replace(/^\/ro(?=\/|$)/, "") || "/";
  const enPath = bare;
  const roPath = bare === "/" ? "/ro" : `/ro${bare}`;
  const canonical = `${origin}${pathname}`;
  const ogImage = image ? (image.startsWith("/") ? `${origin}${image}` : image) : null;

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <link rel="canonical" href={canonical} />}
      {!noindex && <link rel="alternate" hrefLang="en" href={`${origin}${enPath}`} />}
      {!noindex && <link rel="alternate" hrefLang="ro" href={`${origin}${roPath}`} />}
      {!noindex && <link rel="alternate" hrefLang="x-default" href={`${origin}${enPath}`} />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {!noindex && <meta property="og:url" content={canonical} />}
      <meta property="og:locale" content={lang === "ro" ? "ro_RO" : "en_US"} />
      <meta property="og:locale:alternate" content={lang === "ro" ? "en_US" : "ro_RO"} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
}
